module.exports = __webpack_public_path__ + "icon_team_someone.663fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_team_someone.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_team_someone.svg
// module chunks = main